module.exports = __webpack_public_path__ + "media/images/settings-f4fea8efed99bc54195fbba3b9ae9b96.svg";